<template>
  <a-page
    :id="app_id"
    :image_source="image_source"
    :image_height="image_height"
  >
    <div
      class="d-flex justify-center align-center text-center white--text mt-4 mb-12"
      style="position:relative"
      v-if="is_group"
    >
      <div class="px-10 mx-5">
        <h3 class="text-h3 d-block">
          {{ $t("which_hotel_you_want_setup") }}
        </h3>
        <v-btn
          class="mt-10"
          color="secondary"
          rounded
          @click="openHotelSelector"
          >{{ $t("select_hotel") }}
        </v-btn>
      </div>
    </div>
    <div v-else>
      <v-row>
        <v-col cols="12">
          <data-validation></data-validation>
        </v-col>
      </v-row>
    </div>
  </a-page>
</template>

<script>
import aPage from "@/components/aPage";
import DataValidation from "@/components/data-validation/DataValidation.vue";
import { mapGetters } from "vuex";

export default {
  name: "data-validation-view",
  components: {
    aPage,
    DataValidation
  },
  data: () => ({
    app_id: "data-validation-app",
    image_source: "/img/header-2.jpg"
  }),
  computed: {
    image_height: function() {
      return this.is_group ? 300 : 240;
    },
    is_group: function() {
      return this.current_hotel && this.current_hotel.children_number > 0;
    },
    ...mapGetters({
      current_hotel: "current_hotel",
      current_user: "current_user"
    })
  },
  methods: {
    openHotelSelector: function() {
      this.$store.dispatch("setShowHotelList", true);
    }
  }
};
</script>
